import React from 'react'
import { Button, Typography } from '@paintscout/ui'
import { useUserPermissions } from '@paintscout/ui-business'
import { useHistory } from 'react-router-dom'
import {
  DEACTIVATED_BODY_NO_PERMISSION,
  DEACTIVATED_BODY_WITH_PERMISSION,
  DEACTIVATED_BUTTON_LABEL,
  DEACTIVATED_HEADING
} from 'src/util/dunningCopy'
import classnames from 'classnames'
import StatCards from '../../shared/StatCards'
import { useDeactivatedDashboardStyles } from '../useDeactivatedDashboardStyles'
import { useTrialOverDashboardMobileLayoutStyles } from '../../TrialOverDashboard/mobile/useTrialOverDashboardMobileLayoutStyles'

/** The deactivated block screen, mobile (ENG-1532). See the desktop variant for why it reuses the
 * trial-over layout. */
export default function DeactivatedDashboardMobile() {
  const classes = useTrialOverDashboardMobileLayoutStyles()
  const own = useDeactivatedDashboardStyles()
  const { permissionToUpdateBilling } = useUserPermissions()
  const history = useHistory()

  return (
    <div className={classes.root}>
      <div className={classes.leftSection}>
        <Typography className={classes.heading}>
          <span className={classes.headingFirstLine}>
            <span className={classes.headingHighlight}>{DEACTIVATED_HEADING}</span>
          </span>
        </Typography>
        <Typography className={own.body}>
          {permissionToUpdateBilling ? DEACTIVATED_BODY_WITH_PERMISSION : DEACTIVATED_BODY_NO_PERMISSION}
        </Typography>
        {permissionToUpdateBilling && (
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={() => history.push('/settings?section=billing-plan')}
            className={classnames(classes.button, own.button)}
          >
            {DEACTIVATED_BUTTON_LABEL}
          </Button>
        )}
      </div>
      <div className={classes.whiteBackground}>
        <div className={classes.rightSection}>
          <StatCards classes={classes} />
        </div>
      </div>
    </div>
  )
}
